import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Data Extractor',
    entityNamePlural: 'Data Extractors',
    entityNameModule: 'settings',
    basePath: '/settings/data-extractors',
    sort: [{
      id: 'id',
      desc: true,
    }],
  }), [])
}
